const value = {
    imageIsTooBig: 'Изображение слишком большое. Пожалуйста, загрузите картинку не более 5 MB.',
    imageIsTooSmall: 'Изображение слишком маленькое. Минимальный размер изображения 600 x 500 px.',
    incorrectImageFormat: 'Неверный формат файла. Допустимые форматы: PNG, JPG, JPEG.',
    dragAndDropMessage_1: 'Перетащите или',
    dragAndDropMessage_2: 'выберите файл',
    aspectRatio: 'соотношение сторон 4 x 3',
    minSize: 'минимальный размер 600 x 500 px',
    acceptableFormats: 'PNG, JPG, JPEG, не более 5 MB',
    backgroundRequirements: 'прозрачный или одноцветный фон',
  };

export default value;
